import { ActionsUnion, createAction } from 'spw-redux/types';
import { IError, LogoutReason, ToastMessage } from './types';

export const SHOW_TOAST_MESSAGE = 'ui/messages/SHOW_TOAST_MESSAGE';
export const HIDE_TOAST_MESSAGE = 'ui/messages/HIDE_TOAST_MESSAGE';
export const SHOW_ERROR = 'ui/messages/SHOW_ERROR';
export const SHOW_SUCCESS = 'ui/messages/SHOW_SUCCESS';
export const HANDLE_ERROR = 'ui/messages/HANDLE_ERROR';
export const SHOW_PERMANENT_LOGOUT = 'ui/messages/SHOW_PERMANENT_LOGOUT';
export const HIDE_PERMANENT_LOGOUT = 'ui/messages/HIDE_PERMANENT_LOGOUT';
export const COMPARE_VERSION = 'ui/messages/COMPARE_VERSION';
export const SET_VERSION_FETCH_COMPLETE =
  'ui/messages/SET_VERSION_FETCH_COMPLETE';

export const showToastMessage = (toastMessage: ToastMessage, timeout = 3000) =>
  createAction(SHOW_TOAST_MESSAGE, { toastMessage, timeout });

export const hideToastMessage = () => createAction(HIDE_TOAST_MESSAGE);

export const showError = (error: IError) => createAction(SHOW_ERROR, error);

export const showSuccess = (error: IError) => createAction(SHOW_SUCCESS, error);

export const handleError = (error: string | any) => {
  console.error(error);
  return createAction(HANDLE_ERROR, { error });
};

export const showPermanentLogoutMessage = (type: LogoutReason) =>
  createAction(SHOW_PERMANENT_LOGOUT, type);

export const hidePermanentLogoutMessage = () =>
  createAction(HIDE_PERMANENT_LOGOUT);

export const compareVersion = () => createAction(COMPARE_VERSION);

export const setVersionFetchComplete = () =>
  createAction(SET_VERSION_FETCH_COMPLETE);

export const actions = {
  showToastMessage,
  hideToastMessage,
  showError,
  showSuccess,
  handleError,
  showPermanentLogoutMessage,
  hidePermanentLogoutMessage,
  compareVersion,
  setVersionFetchComplete,
};

export type Actions = ActionsUnion<typeof actions>;
